<template>
  <v-navigation-drawer v-model="drawer" app dark temporary>
    <v-list>
      <v-list-tile 
        v-for="(link, i) in links" :key="i"
        :to="link.to"
        :href="link.href"
        @click="onClick($event, link)" >

        <v-list-tile-title class="menu-btn" v-text="link.text" />
      </v-list-tile>
    </v-list>

        <v-dialog v-model="dg_contscts" width="500">
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on">Contacts</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Maria Danishvar</v-card-title>
              <v-card-text>
                <v-layout row align-center justify-center fill-height>
                  <v-flex xs12>
                    <v-card class="mt-2">
                        <v-card-text class="px-5">
                          <p class="subheading">masha_danishvar @ hotmail .co .uk</p>  
                          <p class="subheading">+44 (0) 7402 890775</p>
                      </v-card-text>  	
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dg_contscts = false" >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

  </v-navigation-drawer>
</template>

<script>
import Links from '@/data/links.json'
export default {
  name: 'Drawer',
  props:['drawer'],
    data () {
    return {
      dg_contscts: false,
      links: []
    }
  },
  created(){
    this.getLinks()
  },
  methods: {
    getLinks(){
      this.links = Links
    }
  }
}
</script>